import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loadingPage, selectEnvironment, selectUser } from "store/slices/app";
import * as api from "api/endpoints/superUser";

import TraceSearchMain from "../components/trace/TraceSearchMain";

export default function TraceSearchPage() {
  const userData = useSelector(selectUser);
  const [traceData, setTraceData] = useState(null);
  const [traceId, setTraceId] = useState(null);
  const [matchbookData, setMatchbookData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setSearchLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const environment = useSelector(selectEnvironment);
  const dispatch = useDispatch();

  useEffect(() => {
    setShowNotification(false);
  }, [userData.selectedPartner.id]);

  useEffect(() => {
    setShowNotification(false);
  }, [userData.selectedPartner.id]);

  async function handleSearch(traceId) {
    dispatch(loadingPage(true));
    setSearchLoading(true);
    setTraceId(traceId);
    setTraceData(null);
    setMatchbookData(null);
    setShowNotification(false);
    try {
      const traceData = await api.searchTrace({
        epId: userData.selectedPartner.id,
        traceId: traceId
      });
      setTraceData(traceData.details.data);
    } catch (error) {
      setShowNotification({ type: "error", message: error?.response?.data?.errors });
      setTraceData(false);
    } finally {
      setSearchLoading(false);
      dispatch(loadingPage(false));
    }
  }

  async function handleCall() {
    setShowError(false);
    setLoading(true);
    try {
      const data = {
        traceId: traceId,
        environment: environment === "production" ? "Production" : "Sandbox"
      };
      const matchbookData = await api.callMatchBook(data);
      setMatchbookData(matchbookData);
    } catch (error) {
      setShowError(error?.response?.data?.errors[0]);
    } finally {
      setLoading(false);
    }
  }

  function handleClose() {
    setShowError(false);
    setShowNotification(false);
  }

  return (
    <TraceSearchMain
      traceId={traceId}
      data={traceData}
      showNotification={showNotification}
      loading={loading}
      loadingSearch={loadingSearch}
      showError={showError}
      matchbookData={matchbookData}
      onAlertClose={handleClose}
      onSearch={handleSearch}
      onCall={handleCall}
    />
  );
}
